import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export function useScrollSpy() {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState<string>('');

  useEffect(() => {
    // Reset active section when navigating to home
    if (location.pathname === '/' && !location.hash) {
      setActiveSection('');
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.id;
            if (id) {
              setActiveSection(`#${id}`);
              // Only update URL if we're on the home page
              if (location.pathname === '/') {
                window.history.replaceState(null, '', id === 'hero' ? '/' : `/#${id}`);
              }
            }
          }
        });
      },
      {
        rootMargin: '-20% 0px -35% 0px',
      }
    );

    // Observe all sections
    const sections = document.querySelectorAll('section[id]');
    sections.forEach((section) => observer.observe(section));

    return () => {
      observer.disconnect();
      sections.forEach((section) => observer.unobserve(section));
    };
  }, [location.pathname, location.hash]);

  return activeSection;
}
